import "../Diplomes/diplomes.css"
import diplome from "../../data/diplome.json"
import Back from "../../components/Back/back";
import back from "../../assets/back.png"


function Diplomes (){
    return(
        <section className="diplome">
                <Back title={"Mes différentes Compétences :"} image={back}/>
            <div className="diplome-conteneur">
                  {diplome.map((product)=>{
            return(
                <div key={product.id} className="diplome-contenant">
                    <div className="diplome-img">
                        <img src={product.img} alt="site internet tourcoing"></img>
                    </div>
                </div>
            )
            })}
            </div>
          
        </section>
        )
}
export default Diplomes